import TransitApi from './base'

export default {
  // TODO: Add search, filters and sort params
  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/invoice/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/invoice/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/invoice/details/${params.id}` : '/invoice/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/delete'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getProducts(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      let result = await Api.get(`/invoice/products?${queryString}`)
      return result.data
    } catch (error) {
      return null
    }
  },
}
